/*
 * The bottle inquiry dialog.
 *
 * Opens from the button, from ?inquire-form in the address — the store sends
 * that link out — and again after the form posts, so the reader sees the answer
 * rather than the page they started on.
 *
 * Native <dialog>, so Escape, the focus trap and the backdrop are the browser's.
 */
(() => {
  class BhaktaInquiry extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      /*
       * Every button, not the first one: the buy column offers the inquiry and
       * so does the bar at the foot of the window, and both point here.
       */
      const selector = `[data-bk-inquiry-open][href="#${this.dialog.id}"]`;
      const triggers = document.querySelectorAll(selector).length
        ? document.querySelectorAll(selector)
        : document.querySelectorAll('[data-bk-inquiry-open]');

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.dialog.showModal();
        });
      });

      const close = this.querySelector('[data-bk-inquiry-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());

      /* A click on the backdrop lands on the dialog itself, never on its inside. */
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      const params = new URLSearchParams(window.location.search);
      const asked = params.has('inquire-form');
      const posted = this.dataset.posted === 'true';
      if (asked || posted) this.dialog.showModal();

      if (posted) this.afterSending();
    }

    /*
     * The confirmation shows itself, then steps aside. The URL is tidied at the
     * same time, so a refresh does not re-announce a message already sent.
     */
    afterSending() {
      const url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.searchParams.delete('inquire-form');
      window.history.replaceState({}, '', url);

      const seconds = Number(this.dataset.closeAfter || 0);
      if (!seconds) return;

      const timer = setTimeout(() => this.dialog.close(), seconds * 1000);
      this.dialog.addEventListener('close', () => clearTimeout(timer), { once: true });
    }
  }

  if (!customElements.get('bhakta-inquiry')) {
    customElements.define('bhakta-inquiry', BhaktaInquiry);
  }
})();
